// Object point d'interet
export class PointInterest {
  idPointInterest: number;
  name: string;
  address: string;
  ray: number;
  zoomLevel: number;
  imageUri: string;
  coordinate: {
    lat: number,
    lng: number
  };
  type: 'MARKER' | 'POLYGON' | 'LINE' | number;
  decode: any[];
  hash: string;

  constructor() {
    this.ray = 100;
    this.decode = [];
    this.coordinate = {
      lat: 0,
      lng: 0
    };
  }

}
//Object chauffeur
export class Driver {
  idDriver: number;
  code: string;
  firstName: string;
  lastName: string;
  telephone: string;
  cin: string;
  email: string;
  constructor() {

  }
}
export class DateInterval {

    startDate: Date|number|any;
    endDate: Date|number|any;

    constructor() {

       this.endDate = new Date();
        this.startDate = new Date();
    }
}


// WEBPACK FOOTER //
// ./src/objects/data-management.ts